export default "__VITE_ASSET__1Pk4CktC__"